import React, { useState, useEffect, useContext } from 'react';
import { Outlet, Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

export default function AdminPanel() {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const [openMenu, setOpenMenu] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMobileMenuOpen(false);
    // Force remove the class from the body to ensure sync
    document.body.classList.remove('menu-opened');
  }, [location.pathname]);

  // Add this Effect to handle the global "menu-opened" state
  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.classList.add('menu-opened');
    } else {
      document.body.classList.remove('menu-opened');
    }
  }, [mobileMenuOpen]);
  useEffect(() => {
    const storedTitle = localStorage.getItem('titles');
    const titles = storedTitle ? storedTitle.toString() : "";

    if (titles === "Chat") {
      document.body.classList.add('main-chat-blk');
    } else {
      document.body.classList.remove('main-chat-blk');
    }

    // Cleanup function
    return () => {
      document.body.classList.remove('main-chat-blk');
    };
  }, []);
  const userType = localStorage.getItem('userType');
  const [isLoggedIn, setIsLoggedIn] = useState(null);
  useEffect(() => {
    if (userType === "PATIENT") {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }, [userType]);
  const [isLogout,setIsLogout] =useState(false);
  const handleLogout = async (e) => {

    e.preventDefault();
    setIsLogout(true);
    setMobileMenuOpen(false);
    try {
      const result = await logout();
      console.log("Logout success:", result);
    } catch (err) {
      console.error("Logout error in component:", err);
    } finally {
      setIsLogout(false);
    }
  };
  const handlePatient = async (e) => {
    e.preventDefault();
    localStorage.setItem('titles', 'Dashboard');
    navigate('/patient-dashboard');
  }
  return (
    <>
      <style>{`
    .submenu {
  display: none;
}

@media (max-width: 991px) {
  .main-menu-wrapper {
    position: fixed;
    left: -280px; /* Hide off-screen by default */
    top: 0;
    width: 280px;
    height: 100vh;
    transition: all 0.4s ease;
    z-index: 1050;
    background: #fff;
    display: block !important; /* Ensure it's not set to display: none */
  }

  /* When the state toggles this class, slide it in */
  .main-menu-wrapper.menu-opened {
    left: 0;
    transform: none;
  }
}

/* Show when active */
.has-submenu.active .submenu {
  display: block !important;
}
@media (max-width:768px){
    .footer-logo{
       max-width:90% !important;
      height:auto !important;
      margin-left:5% !important;
      margin-right:5% !important;
    
    }
    .footer-logos{
      max-width:60%;
      height:auto;
      margin-left:20%;
      margin-right:20%;
    
    }
}
/* Desktop hover support */
@media (min-width: 992px) {
  .has-submenu:hover .submenu {
    display: block !important;
  }
}
  @media (min-width: 501px){
    .mob-log{
      display:none !important;;
    }
  }
  @media (max-width: 500px){
     .mob-log{
        display:list-item;
     }
  }
  `}</style>
      <div>
        {/* Main Wrapper */}
        <div className="main-wrapper">
          {/* Header */}
          <header className="header header-trans header-two">
            <div className="container">
              <nav className="navbar navbar-expand-lg header-nav">
                <div className="navbar-header">
                  <button
                    id="mobile_btn"
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      setMobileMenuOpen(prev => !prev);
                    }}
                  >
                    <span className="bar-icon">
                      <span />
                      <span />
                      <span />
                    </span>
                  </button>
                  <a href="/" className="navbar-brand logo">
                    <img src="assets/img/Webnet-Logo.png" className="img-fluid" alt="Logo" />
                  </a>
                </div>
                {/* ${mobileMenuOpen ? "open" : ""} */}
                <div className={`main-menu-wrapper ${mobileMenuOpen ? "menu-opened" : ""}`}>
                  <div className="menu-header">
                    {/* role="button"  onClick={(e)=>{e.preventDefault()}} */}
                    <a href="/" className="menu-logo">
                      <img src="assets/img/Webnet-Logo.png" className="img-fluid" alt="Logo" />
                    </a>
                    <a id="menu_close" className="menu-close" href="/" role="button" onClick={(e) => { e.preventDefault(); setMobileMenuOpen(false); }}>
                      <i className="fas fa-times" />
                    </a>
                  </div>
                  <ul className="main-nav">
                    <li className=" active">
                      <a href="/" onClick={() => setMobileMenuOpen(false)}>Home</a>
                    </li>
                    <li className={`has-submenu ${openMenu ? "active" : ""}`}>
                      <a
                        href="/"
                        role="button"
                        onClick={(e) => {
                          e.preventDefault();
                          setOpenMenu(!openMenu);
                        }}
                      >
                        Doctors <i className="fas fa-chevron-down"></i>
                      </a>

                      <ul className="submenu" style={{ display: openMenu ? 'block' : 'none' }}>
                        <li>
                          <a href="/search-doctors" onClick={() => setMobileMenuOpen(false)}>Search Doctors</a>
                        </li>
                      </ul>
                    </li>
                    {(isLoggedIn) ? <li className="mob-log">
                      <a href="/" role="button" onClick={(e) => { handleLogout(e); }}>Logout</a>
                    </li> : <li className="mob-log">
                      <a href="/login" onClick={() => setMobileMenuOpen(false)}>Login/Signup</a>
                    </li>}
                    {(isLoggedIn) ?
                      <li className="">
                        <a href="/" role="button" onClick={(e) => { setMobileMenuOpen(false); handlePatient(e); }}>My Profile</a>
                      </li> : <></>}
                  </ul>
                </div>
                <ul className="nav header-navbar-rht">
                  {(isLoggedIn) ? (<li className="nav-item">
                    <Link to="/" className="nav-link header-login" onClick={(e) => {
    if (isLogout) {
      e.preventDefault(); // stops navigation
      return;
    }
    handleLogout(e);
  }}>
                      {(isLogout)?"Loading ...":"logout"}
                    </Link>

                  </li>) : (<li className="nav-item">
                    <Link to="/login" className="nav-link header-login" onClick={() => setMobileMenuOpen(false)}>
                      login / Signup
                    </Link>

                  </li>)}

                </ul>
              </nav>
            </div>
          </header>
          {/* /Header */}
          <Outlet />
          {/* Footer */}
          <footer className="footer">
            {/* Footer Top */}
            <div className="footer-top">
              <div className="container">
                <div className="row">
                  <div className="col-lg-3 col-md-6">
                    {/* Footer Widget */}
                    <div className="footer-widget footer-about">
                      <div className="footer-logo">
                        <img src="assets/img/footer-logo.png" alt="logo" className="footer-logos" />
                      </div>
                      <div className="footer-about-content">
                        <p>Our HMS software offers seamless appointment booking,
                          patient management, and doctor scheduling with advanced features. </p>
                        <div className="social-icon">
                          <ul>
                            <li>
                              <a href="https://www.facebook.com/WebnetTechnologiespatna" role="button" onClick={(e) => { e.preventDefault() }}><i className="fab fa-facebook-f" /> </a>
                            </li>
                            <li>
                              <a href="https://x.com/WebnetTechnologies" role="button" onClick={(e) => { e.preventDefault() }}><i className="fab fa-x" /> </a>
                            </li>
                            <li>
                              <a href="https://www.linkedin.com/in/webnet-technologies-a451ab292/" role="button" onClick={(e) => { e.preventDefault() }}><i className="fab fa-linkedin-in" /></a>
                            </li>
                            <li>
                              <a href="https://www.instagram.com/webnettechnologies/" role="button" onClick={(e) => { e.preventDefault() }}><i className="fab fa-instagram" /></a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    {/* /Footer Widget */}
                  </div>
                  <div className="col-lg-3 col-md-6">
                    {/* Footer Widget */}
                    <div className="footer-widget footer-menu">
                      <h2 className="footer-title">For Patients</h2>
                      <ul>
                        <li><a href="/search-doctors">Search for Doctors</a></li>
                        <li><a href="/login">Login</a></li>
                        <li><a href="/sign-up">Register</a></li>
                        <li><a href="/search-doctors">Booking</a></li>
                        <li><a href="/patient-dashboard">Patient Dashboard</a></li>
                      </ul>
                    </div>
                    {/* /Footer Widget */}
                  </div>
                  <div className="col-lg-3 col-md-6">
                    {/* Footer Widget */}
                    <div className="footer-widget footer-menu">
                      <h2 className="footer-title">For Doctors</h2>
                      <ul>
                        <li><a href="https://webnetcare.org/bookingfordemo">Appointments</a></li>
                        <li><a href="https://webnetcare.org/contactus">Chat</a></li>
                        <li><a href="https://webnetcare.org/app/dashboard/login">Login</a></li>
                        <li><a href="https://webnetcare.org/app/dashboard/login">Register</a></li>
                        <li><a href="https://webnetcare.org/bookingfordemo">Schedule a demo</a></li>
                      </ul>
                    </div>
                    {/* /Footer Widget */}
                  </div>
                  <div className="col-lg-3 col-md-6">
                    {/* Footer Widget */}
                    <div className="footer-widget footer-contact">
                      <h2 className="footer-title">Contact Us</h2>
                      <div className="footer-contact-info">
                        <div className="footer-address">
                          <span><i className="fas fa-map-marker-alt" /></span>
                          <p> Bailey Road, Gola Road,<br /> near Petrol Pump, Patna,<br /> Bihar 801503</p>
                        </div>
                        <p>
                          <i className="fas fa-phone-alt" />
                          +91 805 131 6666
                        </p>
                        <p className="mb-0">
                          <i className="fas fa-envelope" />
                          <a href="/" role="button" onClick={(e) => { e.preventDefault() }} className="text-white">support@webnettechnologies.org</a>
                        </p>
                      </div>
                    </div>
                    {/* /Footer Widget */}
                  </div>
                </div>
              </div>
            </div>
            {/* /Footer Top */}
            {/* Footer Bottom */}
            <div className="footer-bottom">
              <div className="container">
                {/* Copyright */}
                <div className="copyright">
                  <div className="row">
                    <div className="col-md-6 col-lg-6">
                      <div className="copyright-text">
                        <p className="mb-0">©  {new Date().getFullYear()} Webnet Technologies. All rights reserved.</p>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-6">
                      {/* Copyright Menu */}
                      <div className="copyright-menu">
                        <ul className="policy-menu">
                          <li><a href="/">Terms and Conditions</a></li>
                          <li><a href="/">Policy</a></li>
                        </ul>
                      </div>
                      {/* /Copyright Menu */}
                    </div>
                  </div>
                </div>
                {/* /Copyright */}
              </div>
            </div>
            {/* /Footer Bottom */}
          </footer>
          {/* /Footer */}
          {/* Cursor */}
          <div className="mouse-cursor cursor-outer" />
          <div className="mouse-cursor cursor-inner" />
          {/* /Cursor */}
        </div>
        {/* /Main Wrapper */}
        {/* ScrollToTop */}
        <div className="progress-wrap active-progress">
          <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
            <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" style={{ transition: 'stroke-dashoffset 10ms linear 0s', strokeDasharray: '307.919px, 307.919px', strokeDashoffset: '228.265px' }}>
            </path>
          </svg>
        </div>
        {/* /ScrollToTop */}
      </div>
    </>
  );
}
